import React, { FC, ReactNode, useMemo } from "react";
import { Button } from "antd";
import { Status } from "../../../common/status/status";
import { ButtonType } from "../../../common";
import { useAppSelector } from "../../../app";
import useActionButton from "../../hooks/useActionButton";
import HoldReasonModal from "./HoldReasonModal/HoldReasonModal";

type Props = {
  id: string;
  status: Status;
  message: string;
  buttonText: string;
  buttonType: ButtonType;
  icon?: ReactNode;
  disabled?: boolean;
  setIsLoading: (loading: boolean) => void;
  openUserConflictModal?: () => void;
};

const ActionButton: FC<Props> = ({
  id,
  status,
  message,
  buttonText,
  buttonType,
  setIsLoading,
  icon,
  disabled = false,
  openUserConflictModal,
}) => {
  const activeButton = useAppSelector((state) => state.appReducer.activeButton);

  const {
    holdReasonPicker,
    isModalOpen,
    isConfirming,
    closeModal,
    handleClick,
    handleApproval,
  } = useActionButton(
    status,
    buttonType,
    message,
    setIsLoading,
    openUserConflictModal,
  );

  const className = useMemo(() => {
    if (activeButton?.id === id) {
      return "btn-focused";
    }

    return "";
  }, [activeButton, id]);

  return (
    <>
      <Button
        id={id}
        icon={icon}
        className={className}
        onClick={handleClick}
        type={buttonType === ButtonType.Approve ? "primary" : "default"}
        ghost={buttonType !== ButtonType.Approve}
        disabled={disabled}
      >
        {buttonText}
      </Button>
      {holdReasonPicker.showPicker ? (
        <HoldReasonModal
          open={isModalOpen}
          reasons={holdReasonPicker.reasons}
          required={holdReasonPicker.isRequired}
          loading={holdReasonPicker.isLoading}
          confirmLoading={isConfirming}
          currentReason={holdReasonPicker.currentReason}
          onClose={closeModal}
          onConfirm={handleApproval}
        />
      ) : null}
    </>
  );
};

export default ActionButton;
